import React from "react"
import Navbar from "./NavbarResponsive"
function Jumbotron(props) {
  return (
    <div className="jumbotron">
      <div
        className="jumbotron-background-image"
        style={{ backgroundImage: `url(${props.bgImage})` }}
      >
        <Navbar />
        {props.children}
      </div>
    </div>
  )
}

export default Jumbotron
